import type { TourConfig } from '../../types/tour.types'

// Leads Purchased (Purchase History). The page header carries a `data-tour` anchor added
// alongside this tour; the filter bar, results table and Download button target stable
// classes/test hooks rendered by PurchasedCompaniesTable.
const leadsPurchasedTour: TourConfig = {
  id: 'leads-purchased',
  title: 'Re-use the leads you already paid for',
  module: 'Purchase History',
  routeName: 'LeadsPurchased',
  order: 13,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Every lead you have purchased, in one place',
      body: 'This is the record of the **company leads you have already bought**. Nothing here costs credits again — come back any time to re-check a company or re-download the data you own.',
    },
    {
      id: 'header',
      target: '[data-tour="lp-header"]',
      placement: 'bottom',
      title: 'Your purchased leads',
      body: 'Everything below is **already yours**. Use this page to review past purchases and pull the data again without spending more credits.',
    },
    {
      id: 'filter',
      target: '.ph-filter-bar',
      placement: 'bottom',
      title: 'Find a past purchase fast',
      body: 'Narrow the list by **date range** — and, for admins, **by user** — then hit **Find**. The view defaults to the last month, so widen the dates to go further back.',
    },
    {
      id: 'table',
      target: '.ph-table-card',
      placement: 'top',
      title: 'Review what you bought',
      body: 'Each row is a purchased company. Open **Info** for the full company profile, follow the **Bulk Download** link to the export it came from, and **tick the rows** you want to re-download.',
    },
    {
      id: 'download',
      target: '[data-test="download-button"]',
      placement: 'bottom',
      title: 'Download again — free',
      body: 'With rows selected, export them straight to **CSV or Excel**. Re-downloading leads you already own never costs credits.',
    },
  ],
}

export default leadsPurchasedTour
